import { z } from 'zod';
import { optionalString } from './common.js';
import { paginationQuerySchema } from '../pagination.js';
/**
 * Configuration SMTP (stockée dans les paramètres, clé `email`).
 * Le mot de passe (`pass`) laissé vide est conservé côté serveur (jamais
 * renvoyé au client) — cf. masquage dans le service email.
 */
export const emailConfigSchema = z.object({
    enabled: z.boolean().default(false),
    host: optionalString(200),
    port: z.coerce.number().int().min(1).max(65535).default(587),
    secure: z.boolean().default(false),
    user: optionalString(200),
    pass: z.string().max(300).optional(),
    from: optionalString(200),
});
export const testEmailSchema = z.object({
    to: z.string().trim().email('Email invalide'),
});
// --- Modèles d'emails -----------------------------------------------------
export const createEmailTemplateSchema = z.object({
    name: z.string().trim().min(1, 'Nom requis').max(120),
    subject: z.string().trim().min(1, 'Sujet requis').max(300),
    body: z.string().trim().min(1, 'Corps requis').max(20000),
    description: optionalString(255),
});
export const updateEmailTemplateSchema = createEmailTemplateSchema.partial();
/** Variables interpolables dans les sujets/corps (substituées à l'envoi). */
export const EMAIL_VARIABLES = [
    { key: '{{client}}', label: 'Nom du destinataire' },
    { key: '{{entreprise}}', label: "Nom de l'entreprise" },
    { key: '{{date}}', label: 'Date du jour' },
];
/** Remplace les variables connues dans un texte. */
export function renderTemplate(text, vars) {
    return text.replace(/\{\{\s*(\w+)\s*\}\}/g, (_m, name) => vars[name] ?? `{{${name}}}`);
}
// --- Envoi & historique ---------------------------------------------------
export const sendEmailSchema = z.object({
    to: z.string().trim().email('Email invalide'),
    subject: z.string().trim().min(1, 'Sujet requis').max(300),
    body: z.string().trim().min(1, 'Corps requis').max(20000),
    templateId: optionalString(60),
    toType: z.enum(['customer', 'user', 'custom']).optional(),
    toId: optionalString(60),
});
export const emailHistoryQuerySchema = paginationQuerySchema;
//# sourceMappingURL=email.js.map